(() => {
  try {
    const selectors = {
      name: "[data-distributor-name]",
      aboutYou: "[data-distributor-about-you]",
      city: "[data-distributor-city]",
      state: "[data-distributor-state]",
      phone: "[data-distributor-phone]",
      email: "[data-distributor-email]",
      image: "[data-distributor-image]",
      hideOnSelected: "[data-hideOnSelected]",
      showOnSelected: "[data-showOnSelected]",
      yourDistributorModal: "#yourDistributorModal",
      distributorMismatchModal: "#distributorMismatchModal",
      locatorModal: "#locatorModal",
      yourDistributorModalOpenBtn: ".distributor-selector-modal__open",
      yourDistributorModalCloseBtn: ".distributor-selector-modal__close",
      changeDistributor: "#changeDistributor",
      removeDistributor: "#removeDistributor",
      locatorModalOpenBtn: ".locator-modal__open",
      locatorModalCloseBtn: ".locator-modal__close",
      currentPartner: "[data-current-distributor]",
      preferredPartner: "[data-preferred-distributor]",
      currentPartnerSiteName: "[data-current-distributor-site-name]",
      preferredPartnerSiteName: "[data-preferred-distributor-site-name]",
    };

    const ANIMATION_DURATION = 400; // Match the CSS transition duration

    // update customer record with selected rep
    const updateDOMElements = (rep) => {
      console.log("updatePreferredRep: ", rep);

      // update dom
      document.querySelectorAll(selectors.name).forEach((element) => {
        element.textContent = rep.full_name;
      });
      document.querySelectorAll(selectors.aboutYou).forEach((element) => {
        element.textContent = rep.about_you;
      });
      document.querySelectorAll(selectors.city).forEach((element) => {
        element.textContent = rep.city;
      });
      document.querySelectorAll(selectors.state).forEach((element) => {
        element.textContent = rep.state;
      });
      document.querySelectorAll(selectors.phone).forEach((element) => {
        element.textContent = rep.phone;
      });
      document.querySelectorAll(selectors.email).forEach((element) => {
        element.textContent = rep.email;
      });

      if (rep.image) {
        document.querySelectorAll(selectors.image).forEach((element) => {
          element.src = rep.image;
        });
      }

      document.querySelectorAll(selectors.hideOnSelected).forEach((element) => {
        element.style.display = "none";
      });
      document.querySelectorAll(selectors.showOnSelected).forEach((element) => {
        element.style.display = "block";
      });
    };

    const showModal = (modal) => {
      modal.classList.remove("hidden");
      // Force a reflow
      modal.offsetHeight;
      modal.classList.add("show");
    };

    const hideModal = (modal) => {
      modal.classList.remove("show");
      setTimeout(() => {
        modal.classList.add("hidden");
      }, ANIMATION_DURATION);
    };

    const loadUrlAction = async () => {
      const urlSearchParam = new URLSearchParams(window.location.search);
      const action = urlSearchParam.get("action");

      if (!action) return;

      if (action === "checkout_change_insider") {
        showModal(locatorModal);
      }
    };

    document.addEventListener("DOMContentLoaded", function () {
      const yourDistributorModal = document.querySelector(
        selectors.yourDistributorModal
      );
      const yourDistributorModalOpenBtn = document.querySelectorAll(
        selectors.yourDistributorModalOpenBtn
      );
      const yourDistributorModalCloseBtn = document.querySelectorAll(
        selectors.yourDistributorModalCloseBtn
      );

      const distributorMismatchModal = document.querySelector(
        selectors.distributorMismatchModal
      );

      const changeDistributor = yourDistributorModal.querySelector(
        selectors.changeDistributor
      );
      const removeDistributor = yourDistributorModal.querySelector(
        selectors.removeDistributor
      );

      const locatorModal = document.querySelector(selectors.locatorModal);
      const locatorModalOpenBtn = document.querySelectorAll(
        selectors.locatorModalOpenBtn
      );

      // attach event handlers
      yourDistributorModalOpenBtn.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          showModal(yourDistributorModal);
        });
      });

      yourDistributorModalCloseBtn.forEach((btn) => {
        btn.addEventListener("click", () => hideModal(yourDistributorModal));
      });

      yourDistributorModal.addEventListener("click", (e) => {
        if (e.target === yourDistributorModal) {
          hideModal(yourDistributorModal);
        }
      });

      locatorModalOpenBtn.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          showModal(locatorModal);
        });
      });

      changeDistributor.addEventListener("click", (e) => {
        e.preventDefault();
        hideModal(yourDistributorModal);
        showModal(locatorModal);
      });

      removeDistributor.addEventListener("click", (e) => {
        e.preventDefault();
        hideModal(yourDistributorModal);
        removeCurrentSite();
      });

      locatorModal.addEventListener("click", (e) => {
        if (e.target === locatorModal) {
          hideModal(locatorModal);
        }
      });

      const updateCurrentSite = async (distributor) => {
        console.log("updateCurrentSite: ", distributor);

        // set distribtor local storage and session storage
        localStorage.setItem(
          "CURRENT_SITE",
          distributor.site_name.toLowerCase()
        );
        sessionStorage.setItem(
          "PREFERRED_SITE",
          distributor.site_name.toLowerCase()
        );
        sessionStorage.setItem(
          `CACHE-${distributor.site_name.toLowerCase()}`,
          JSON.stringify(distributor)
        );

        // set distribtor in backend
        await window.backend.setDistributor(distributor.site_name);

        updateDOMElements(distributor);

        const currentURL = new URL(window.location);
        currentURL.searchParams.set("ref", distributor.site_name.toLowerCase());

        await new Promise((resolve) => setTimeout(resolve, 500));

        const urlSearchParam = new URLSearchParams(window.location.search);
        const action = urlSearchParam.get("action");
        if (action && action === "checkout_change_insider") {
          window.customCheckout();
        } else {
          location.replace(currentURL);
        }
      };

      const removeCurrentSite = async () => {
        console.log("removeCurrentSite");

        // remove current site from localStorage and sessionStorage
        localStorage.removeItem("CURRENT_SITE");
        sessionStorage.removeItem("PREFERRED_SITE");

        // remove distributor from backend
        await window.backend.removeDistributor();

        // remove ref from url
        const currentURL = new URL(window.location);
        currentURL.searchParams.delete("ref");
        await new Promise((resolve) => setTimeout(resolve, 500));
        location.replace(currentURL);
      };

      // mismatch modal event listeners
      document
        .querySelectorAll(selectors.currentPartnerSiteName)
        .forEach((element) => {
          element.addEventListener("click", async (e) => {
            e.preventDefault();
            console.log("currentPartnerSiteName clicked");
            // handle updating current partner
            const site_name = element.getAttribute(
              "data-current-distributor-site-name"
            );
            const currentPartner = await window.backend.getDistrbutorBySiteName(
              site_name
            );
            await updateCurrentSite(currentPartner);
            hideModal(distributorMismatchModal);
          });
        });

      document
        .querySelectorAll(selectors.preferredPartnerSiteName)
        .forEach((element) => {
          element.addEventListener("click", async (e) => {
            e.preventDefault();
            console.log("preferredPartnerSiteName clicked");
            // handle updating preferred partner
            const site_name = element.getAttribute(
              "data-preferred-distributor-site-name"
            );
            const preferredPartner =
              await window.backend.getDistrbutorBySiteName(site_name);
            await updateCurrentSite(preferredPartner);
            hideModal(distributorMismatchModal);
          });
        });

      const updateMismatchModal = (currentPartner, preferredPartner) => {
        document
          .querySelectorAll(selectors.currentPartner)
          .forEach((element) => {
            element.textContent = currentPartner.full_name;
          });
        document
          .querySelectorAll(selectors.preferredPartner)
          .forEach((element) => {
            element.textContent = preferredPartner.full_name;
          });
        document
          .querySelectorAll(selectors.currentPartnerSiteName)
          .forEach((element) => {
            element.setAttribute(
              "data-current-distributor-site-name",
              currentPartner.site_name
            );
          });
        document
          .querySelectorAll(selectors.preferredPartnerSiteName)
          .forEach((element) => {
            element.setAttribute(
              "data-preferred-distributor-site-name",
              preferredPartner.site_name
            );
          });
      };

      document.addEventListener("theme:partner:render", (event) => {
        const partner = event.detail.partner;
        updateDOMElements(partner);
      });

      document.addEventListener("theme:partner:mismatch", (evt) => {
        const currentPartner = evt.detail.current;
        const preferredPartner = evt.detail.preferred;
        updateMismatchModal(currentPartner, preferredPartner);
        showModal(distributorMismatchModal);
      });

      loadUrlAction();

      // handle postmessage from locator iframe
      var eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";

      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

      eventer(
        messageEvent,
        async function (e) {
          var key = e.message ? "message" : "data";
          var data = e[key];

          switch (data.type) {
            case "setPrefPartner":
              console.log("switch setPrefPartner");
              hideModal(locatorModal);
              // Set pref partner
              const distributorData = JSON.parse(data.data);
              const distributorSiteName = distributorData.siteName;

              localStorage.setItem(
                "CURRENT_SITE",
                distributorSiteName.toLowerCase()
              );
              sessionStorage.setItem(
                "PREFERRED_SITE",
                distributorSiteName.toLowerCase()
              );

              if (window.customer) {
                await window.backend.setDistributor(distributorSiteName);
              }

              const distributor = await window.backend.getDistrbutorBySiteName(
                distributorSiteName
              );
              distributor.site_name = distributorSiteName;
              await updateCurrentSite(distributor);

              break;
            case "closeModal":
              console.log("switch Close modal");
              hideModal(locatorModal);

              const urlSearchParam = new URLSearchParams(
                window.location.search
              );
              const action = urlSearchParam.get("action");
              if (action && action === "checkout_change_insider") {
                window.customCheckout();
              }
              break;
            default:
              break;
          }
        },
        false
      );
    });
  } catch (e) {
    console.error(e);
  }
})();
